import React from 'react';
import './PillTabs.css';

export type Tab = {
  title: string;
  disabled?: boolean;
};


type PillTabsProps = {
  tabs: Tab[];
  bottomText?: string;
  onTabChange: (selectedTab: string) => void;
  selectedTab: string;
  bottomTextIndex?: number;
};

const PillTabs: React.FC<PillTabsProps> = ({
  tabs,
  bottomText,
  onTabChange,
  selectedTab,
  bottomTextIndex = -1,
}) => {
  return (
    <nav className="tabs-container">
      <ul className="tabs">
        {tabs.map((tab, index) => (
          <li
            key={index}
            className={`${tab.disabled ? 'disabled': ''} tab ${selectedTab === tab.title ? 'active' : ''}`}
            onClick={() => onTabChange(tab.title)}
          >
            {tab.title}
            {bottomText && index === bottomTextIndex && (
              <span className="small-text">{bottomText}</span>
            )}
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default PillTabs;